module.exports = __webpack_public_path__ + "img/bg_print_a.38a3e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg_print_a.jpg
// module id = 7KzK
// module chunks = 172